const BASE_TITLE = "イロドキー施設管理";

const envToPrefix = (env?: string): string => {
  if (!env) return "Production";
  const value = env.toLowerCase();
  if (value.startsWith("dev") || value === "development") {
    return "Dev";
  }
  if (value.startsWith("staging") || value === "stg") {
    return "Staging";
  }
  if (value.startsWith("prod") || value === "production") {
    return "";
  }
  return "";
};

const getEnvironment = (): string => {
  const env = process.env.REACT_APP_APP_ENV || "production";
  return envToPrefix(env);
};

const setAppTitle = (baseTitle: string = BASE_TITLE) => {
  const environment = getEnvironment();
  if (environment === "") {
    document.title = baseTitle;
    return;
  }
  document.title = `${environment} - ${baseTitle}`;
};

export { setAppTitle, getEnvironment };
